import React, { Component } from 'react'
import Measure from 'react-measure'
require(`../assets/${process.env.PAGE}/css/components/camera.css`);

const CAPTURE_OPTIONS = {
    audio: false,
    video: { facingMode: "environment" }
};

class Camera extends Component {
  constructor(props){
    super(props)
    this.state = {
        stream: null,
        picture: null,
        saved: false,
        playing: false,
        hasCameraPermission: false,
        mediaSize:{
          height:0,
          width:0,
          aspectRatio: 1.586,
        }
    }
    this.video = null;
    this.containerVideo = null;
    this.canvas = null;
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleCanPlay = this.handleCanPlay.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.onCapture = this.onCapture.bind(this);
    this.handleCapture = this.handleCapture.bind(this);
    this.onClear = this.onClear.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  componentDidMount(){
    navigator.mediaDevices
    .getUserMedia(CAPTURE_OPTIONS)
    .then(stream => {
        this.setState({
          ...this.state,
          stream: stream,
          hasCameraPermission: true})
    });
  }

  componentDidUnMount(){
    this.state.stream.getTracks().forEach(track => {
        track.stop();
    });
  }

  handleOnChange(event){
    event.preventDefault()
    if(this.props.onChange){
      this.props.onChange(this.state.picture);
    }
    this.setState({
      ...this.state,
      saved: true
    })
  }

  handleCapture(event) {
    const { mediaSize } = this.state;
    const offset = this.calculateOffset(mediaSize, this.video);
    console.log(offset)
    console.log(mediaSize)
    console.log(this.video.videoHeight)
    console.log(this.video.videoWidth)
    event.preventDefault()
    const context = this.canvas.getContext('2d');
    context.drawImage(this.video,
                      offset.x,
                      offset.y,
                      mediaSize.width,
                      mediaSize.height,
                      0,
                      0,
                      mediaSize.width,
                      mediaSize.height);

    this.canvas.toBlob(blob => this.onCapture(blob), "image/jpeg", 1);
  }

  handleResize(contentRect){
    const { mediaSize } = this.state;

    if(contentRect.entry){
      this.setState({
        ...this.state,
        mediaSize:{
          width: contentRect.entry.width,
          height: Math.round(contentRect.entry.width / mediaSize.aspectRatio),
          aspectRatio: mediaSize.aspectRatio
        }
      })
    }
  }

  onCapture(blob) {
    this.setState({...this.state, picture: blob});
  }

  handleClear() {
    const context = this.canvas.getContext("2d");
    context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.onClear();
  }

  onClear(blob) {
    this.setState({...this.state, picture: undefined});
  }


  handleCanPlay() {
    const { mediaSize } = this.state
    const newAspectRatio = this.calculateRatio(this.video.videoHeight, this.video.videoWidth);

    this.setState({
      ...this.state,
      playing: true,
      mediaSize:{
        ...mediaSize,
        aspectRatio: (newAspectRatio || mediaSize.aspectRatio)
      }
    })
    this.video.play();
  }

  calculateRatio(height, width){
    if (height && width) {
      const isLandscape = height <= width;
      const ratio = isLandscape ? width / height : height / width;
      return ratio;
    }
  }

  calculateDocumentFrame(containerWidth, containerHeight, frameAspectRatio, defaultFixedSide=null){
    let fixedSide = (containerWidth >= containerHeight) ? containerWidth : containerHeight;
    if(defaultFixedSide){
      fixedSide = (defaultFixedSide === 'width') ? containerWidth : containerHeight
    }
    const variableSide = (fixedSide == containerWidth) ? containerHeight : containerWidth;
    const fixedSideFrame = 20;
    const fixedContentSize = Math.round(fixedSide - (fixedSideFrame * 2));
    const variableContentSize = Math.round(fixedContentSize / frameAspectRatio);
    const variableSideFrame = ((variableSide - variableContentSize) / 2);
    return {
      frameWidth: (fixedSide === containerWidth) ? fixedSideFrame : variableSideFrame,
      frameHeight:(fixedSide === containerHeight) ? fixedSideFrame : variableSideFrame,
    }
  }

  calculateOffset(videoContainer, video){
    if (video && videoContainer){
        return {
            x: video.videoWidth > videoContainer.width ?  Math.round((video.videoWidth - videoContainer.width) / 2) : 0,
            y: video.videoHeight > videoContainer.height ?  Math.round((video.videoHeight - videoContainer.height) / 2) : 0,
        }
    }
  }

  render() {
    const { mediaSize, hasCameraPermission } = this.state;
    const { shapeStyle } = this.props;

    if (this.state.stream && this.video && !this.video.srcObject) {
        this.video.srcObject = this.state.stream;
    }

    const documentFrames = this.calculateDocumentFrame(mediaSize.width, mediaSize.height, shapeStyle.aspectRatio, shapeStyle.defaultFixedSide);
    const videoOffset = this.calculateOffset(mediaSize, this.video);

    const ConfirmButtons = (<div>
                              <button className='btn btn-primary action-button' onClick={this.handleOnChange}><span className="glyphicon glyphicon-ok" aria-hidden="true"></span></button>
                              <button className='btn btn-primary action-button' onClick={this.handleClear}><span className="glyphicon glyphicon-remove" aria-hidden="true"></span></button>
                            </div>);
    const shownButtons = this.state.picture ? ConfirmButtons :  (<button onClick={this.handleCapture} className='btn btn-primary btn-lg action-button'>
                                                                    <span className="glyphicon glyphicon-camera" aria-hidden="true">
                                                                    </span>
                                                                </button>);
    const alert = (
      <div class="alert alert-warning" role="alert">
        <span>
          Debes aceptar el permiso para poder acceder a tu camara.
        </span>
      </div>
    );


    return (
      <div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            { (!hasCameraPermission && alert) || 
              (<Measure onResize={this.handleResize}>
                {({ measureRef }) => (
                  <div 
                  ref={measureRef}
                  style={{
                    position: 'relative',
                    maxHeight: this.video && this.video.videoHeight,
                    maxWidth: this.video && this.video.videoWidth,
                    height: this.state.mediaSize.height,
                    overflow: (this.video && this.video.videoHeight && 'hidden')
                  }}>
                    <video 
                      ref={(component) => { this.video = component }}
                      onPlay={this.handleCanPlay}
                      style={{
                        top: `-${(videoOffset ? videoOffset.y : 0)}px`,
                        left: `-${videoOffset ? videoOffset.x : 0}px`,
                        position: 'absolute'
                      }}
                      hidden={false}
                      autoPlay
                      playsInline
                      muted
                    />
                    <div style={{
                      position: 'absolute',
                      top: documentFrames.frameHeight,
                      right: documentFrames.frameWidth,
                      bottom: documentFrames.frameHeight,
                      left: documentFrames.frameWidth,
                      boxShadow: '0px 0px 20px 300px rgba(0, 0, 0, 0.6)',
                      border: '1px solid #ffffff',
                      borderRadius: 10,
                      ...shapeStyle,
                    }}>
                    </div>
                    <canvas
                        ref={(component) => {this.canvas = component}}
                        style={{
                          position: 'absolute',
                        }}
                        width= {this.state.mediaSize.width}
                        height= {this.state.mediaSize.height}
                    />
                  </div>
              )
            }
            </Measure>)
            }
          </div>
        </div>
        <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 text-center">
              {(!this.state.saved && shownButtons)}
            </div>
        </div>
      </div>
    );
  }
}
module.exports = Camera


/** WEBPACK FOOTER **
 ** ./src/components/Camera.js
 **/